/* eslint-env browser */

import * as React from 'react'
import isEmail from 'validator/lib/isEmail'
const PropTypes = require('prop-types')
const axios = require('axios')
const { captureException } = require('../../../../render/client/clientjs/services/sentry-service')

const Counterpart = require('@gandi/counterpart').Instance

const translate = new Counterpart()
translate.registerTranslations('en', require('./i18n/en'))
translate.registerTranslations('fr', require('./i18n/fr'))

class ResetPasswordForm extends React.Component {
  constructor() {
    super()
    this.state = {
      email: '',
      emailStarted: false,
    }
    this.handleChange = this.handleChange.bind(this)
    this.validationState = this.validationState.bind(this)
    this.isSignupButtonEnabled = this.isSignupButtonEnabled.bind(this)
    this.submit = this.submit.bind(this)
  }

  componentWillMount() {
    if (this.props.appConfig.locale.identifierShort !== translate.getLocale()) {
      translate.setLocale(this.props.appConfig.locale.identifierShort)
    }
  }

  isSignupButtonEnabled() {
    if (this.state.isSubmitting) {
      return false
    }
    if (!this.state.emailStarted) {
      return false
    }
    if (typeof this.validationState('email') !== 'undefined') {
      return false
    }
    return true
  }

  submit(e) {
    e.preventDefault()
    if (this.state.isSubmitting) {
      return
    }
    const newState = this.state
    newState.errorMessage = undefined
    newState.successMessage = undefined
    newState.isSubmitting = true
    this.setState(newState)
    const refToThis = this

    axios
      .post('/api/passwordResetTokens', this.state)
      .then(function(/* res */) {
        const newState2 = refToThis.state
        newState2.isSubmitting = false
        newState2.successMessage = 'ask.successMessage'
        refToThis.setState(newState2)
      })
      .catch(function(err) {
        captureException(err)
        const newState3 = refToThis.state
        newState3.isSubmitting = false
        newState3.errorMessage = 'ask.unknownError'
        refToThis.setState(newState3)
      })
  }

  signupButtonTitle() {
    return this.state.isSubmitting
      ? translate.translate('submit.loading')
      : translate.translate('submit.changePassword')
  }

  validationState(formElementName) {
    if (formElementName === 'email') {
      if (this.state.emailStarted && !isEmail(this.state.email)) {
        return 'error'
      }
    }
    return undefined
  }

  handleChange() {
    const passwordStarted = this.state.emailStarted || this.emailInput.value.length > 0
    this.setState({
      email: this.emailInput.value,
      emailStarted: passwordStarted,
    })
  }

  render() {
    return (
      <form className="form form-horizontal" onSubmit={this.submit}>
        <div className="field is-horizontal">
          <div className="field-label is-normal">
            <label className="label" htmlFor="input-email-reset-password">
              {translate.translate('email.label')}
            </label>
          </div>
          <div className="field-body">
            <div className="field">
              <div className="control">
                <input
                  className={`input${this.validationState('email') ? ' is-danger' : ''}`}
                  type="email"
                  id="input-email-reset-password"
                  placeholder={translate.translate('email.label')}
                  ref={c => {
                    this.emailInput = c
                  }}
                  onChange={this.handleChange}
                  autoCapitalize="off"
                  autoCorrect="off"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="columns is-mobile is-multiline is-centered">
          <div
            className="column is-12 has-text-weight-bold has-text-danger"
            style={{ display: this.state.errorMessage ? '' : 'none' }}
          >
            {this.state.errorMessage && translate.translate(this.state.errorMessage)}
          </div>
          <div
            className="column is-12 has-text-weight-bold has-text-success"
            style={{ display: this.state.successMessage ? '' : 'none' }}
          >
            {this.state.successMessage && translate.translate(this.state.successMessage)}
          </div>
          <div
            className="column is-12 text-right"
            style={{ marginTop: 8, display: this.state.successMessage ? 'none' : '' }}
          >
            <button className="button is-primary" type="submit" disabled={!this.isSignupButtonEnabled()}>
              {this.signupButtonTitle()}
            </button>
          </div>
        </div>
      </form>
    )
  }
}

ResetPasswordForm.propTypes = {
  appConfig: PropTypes.object.isRequired,
}

module.exports = ResetPasswordForm
